import { CDN_IMG_URL } from "@workspace/casino_config/cdn";

const getCdnIcon = (handle = "", extension = ".svg") =>
  `${CDN_IMG_URL}/icons/${handle}${extension}`;

export default getCdnIcon;
